// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "vendor." + chunkId + "." + {"3197":"a73cc49b9b937fbc","8840":"f8b0041be338cb31"}[chunkId] + ".chunk.css";
};